import { parse } from 'date-fns';
export const CleanupFilterItems = (filterModel, fields) => {
    if (!(filterModel === null || filterModel === void 0 ? void 0 : filterModel.items.length) || !fields) {
        return undefined;
    }
    const items = filterModel.items
        .map((filterItem) => {
        var _a, _b, _c, _d, _e, _f;
        if (filterItem.value === undefined) {
            return undefined;
        }
        if (((_a = fields['string']) === null || _a === void 0 ? void 0 : _a.length) && fields['string'].includes(filterItem.field)) {
            return Object.assign(Object.assign({}, filterItem), { type: 'string' });
        }
        if (((_b = fields['date']) === null || _b === void 0 ? void 0 : _b.length) && fields['date'].includes(filterItem.field)) {
            const value = parse(filterItem.value.toString(), 'yyyy-MM-dd', new Date()).toISOString();
            return Object.assign(Object.assign({}, filterItem), { value, type: 'date' });
        }
        if (((_c = fields['dateTime']) === null || _c === void 0 ? void 0 : _c.length) && fields['dateTime'].includes(filterItem.field)) {
            const value = parse(filterItem.value.toString(), 'yyyy-MM-dd HH:mm', new Date()).toISOString();
            return Object.assign(Object.assign({}, filterItem), { value, type: 'dateTime' });
        }
        if (((_d = fields['number']) === null || _d === void 0 ? void 0 : _d.length) && fields['number'].includes(filterItem.field)) {
            const value = Number(filterItem.value);
            return Object.assign(Object.assign({}, filterItem), { value, type: 'number' });
        }
        if (((_e = fields['singleSelect']) === null || _e === void 0 ? void 0 : _e.length) && fields['singleSelect'].includes(filterItem.field)) {
            return Object.assign(Object.assign({}, filterItem), { type: 'singleSelect' });
        }
        if (((_f = fields['boolean']) === null || _f === void 0 ? void 0 : _f.length) && fields['boolean'].includes(filterItem.field)) {
            const value = filterItem.value.toString() === 'true';
            return Object.assign(Object.assign({}, filterItem), { value, type: 'boolean' });
        }
        return undefined;
    })
        .filter((filter) => filter !== undefined);
    if (!items.length) {
        return undefined;
    }
    return Object.assign(Object.assign({}, filterModel), { items: items });
};
